import { render, staticRenderFns } from "./UserGrid.vue?vue&type=template&id=b5288650&scoped=true&"
import script from "./UserGrid.vue?vue&type=script&lang=js&"
export * from "./UserGrid.vue?vue&type=script&lang=js&"
import style0 from "./UserGrid.vue?vue&type=style&index=0&id=b5288650&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5288650",
  null
  
)

export default component.exports